import { ExitToApp } from '@mui/icons-material';
import { AppBar, CardMedia, Divider, IconButton } from '@mui/material';
import { Box } from '@mui/system';
import { Location } from 'history';
import { Redirect, Route, Switch, useRouteMatch, useHistory } from 'react-router';
import { logout } from '../../redux-store/actions/auth';
import LoginOtp from '../auth/loginOtp';
import { CommonLayout, Footer } from '../commonComponents';
import { Routes } from '../investors/routes';
import InvestorApplication from './investor-application';
import { useDispatch, useSelector } from 'react-redux';
import { USER_ROLES } from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import MobileLogin from '../auth/MobileLogin';
import LoginRequireRoute from '../../routes/LoginRequireRoute';
import ProtectedRoute from '../../routes/ProtectedRoute';

export const EditApplication = ({
  location,
}: {
  location: Location<{ id: string; applicant1ReferenceId?: string }>;
}): JSX.Element => {
  const { id, applicant1ReferenceId } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();

  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    USER_ROLES.AMCAPPROVER.includes(role)
      ?
      // <CommonLayoutForPOA>
      <CommonLayout>
        <Routes id={id} applicant1ReferenceId={applicant1ReferenceId} />
      </CommonLayout>
      // </CommonLayoutForPOA>
      :
      (
        <Box
          sx={{
            bgcolor: { xs: '', sm: 'rgba(238, 244, 251, 0.5)' },
          }}>
          <AppBar position="fixed" elevation={0} sx={{ bgcolor: 'common.white' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingRight: { xs: 0, sm: '48px' },
                paddingLeft: { xs: 0, sm: '48px' },
              }}>
              <CardMedia
                component="img"
                // src="/images/kfintechHeaderImg.svg"
                // src="/images/mPowerWealth_Logo.svg"
                src="/images/nexedge_logo_dark.png"
                // alt="Logo"
                // sx={{ width: '160px', m: 3, mb: 2, mt: 2 }}
                sx={{
                  // width: '15rem',
                  // margin: "20px 0px 0px 15px"
                  width: '12rem',
                  margin: '30px 0px 0px 30px'
                }}
                role="img"
                aria-label="Go to home page"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    history.push("/");
                  }
                }}
              />
              {role !== USER_ROLES.INVESTOR && (
                <Box sx={{ display: 'flex' }}>
                  <IconButton
                    onClick={() => {
                      dispatch(logout());
                      history.push('/login');
                    }}>
                    <ExitToApp fontSize="large" sx={{ color: 'primary.main' }} />
                  </IconButton>
                </Box>
              )}
            </Box>
          </AppBar>
          <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
          <Box sx={{ py: 3, px: { xs: 2, sm: 10 }, mt: 10 }}>
            <Routes id={id} applicant1ReferenceId={applicant1ReferenceId} />
          </Box>
          <Footer />
        </Box>
      )
  );
};

const InvestorRoutes = (): JSX.Element => {
  const { path } = useRouteMatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  return (
    <Switch>
      <Route
        exact
        path={path}
        render={(props: any) => (
          <Redirect to={`${path}/:referenceId/investor-login`} from={props.location.state} />
        )}
      />
      <Route path={`${path}/:referenceId/investor-login`} component={MobileLogin} />
      <Route path={`${path}/:referenceId/verify-pan`} component={LoginOtp} />
      <Route path={`${path}/:referenceId/application-details`} component={InvestorApplication} />
      {/* {USER_ROLES.AMCAPPROVER.includes(role)
        ?
        <ProtectedRoute path={`${path}/edit-application`} component={EditApplication} acceptedRoles={[USER_ROLES.AMCAPPROVER]} />
        : <Route path={`${path}/edit-application`} component={EditApplication} />
      } */}
      <Route path={`${path}/edit-application`} component={EditApplication} />
      <LoginRequireRoute path="*" />
    </Switch>
  );
};

export default InvestorRoutes;
